import { render } from "./SupportMap.vue?vue&type=template&id=7047f840&scoped=true"
import script from "./SupportMap.vue?vue&type=script&lang=js"
export * from "./SupportMap.vue?vue&type=script&lang=js"

import "./SupportMap.vue?vue&type=style&index=0&id=7047f840&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7047f840"]])

export default __exports__